<template>
  <AuthForm>
    <template v-slot:header>
      <h2 v-translate>Se connecter</h2>
      <p v-if="publicationAccessParameters.private" class="private-message" v-html="privateMessage"></p>
      <p v-if="isConfirmed" class="private-message" v-translate>
        Félicitations ! Votre compte a été validé. Vous pouvez maintenant vous connecter à l'aide de votre identifiant
        et de votre mot de passe :
      </p>
    </template>
    <form role="form" @submit.prevent="submit">
      <error-messages :errors="errors"></error-messages>
      <div class="row">
        <div class="col-md-6">
          <input
            v-focus
            v-model="credentials.email"
            type="text"
            name="email"
            class="form-control"
            :placeholder="titles.email"
          />
          <br />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input
            v-model="credentials.password"
            type="password"
            name="password"
            id
            class="form-control"
            :placeholder="titles.password"
          />
        </div>
        <div class="col-md-4 pl-0 pl-sm-4">
          <a :href="forgotPasswordUrl" class="forgot-password" target="_top" v-translate>Mot de passe oublié ?</a>
        </div>
      </div>
      <div class="submit row align-items-center">
        <div class="col-md-3">
          <input type="submit" :value="titles.submit" />
        </div>
        <div class="col-md-6 pl-4 pl-sm-0 my-2 my-sm-0">
          <label class="checkbox">
            <input v-model="credentials.remember_me" type="checkbox" class="form-check-input" value />
            <translate>Se souvenir de ma connexion</translate>
          </label>
        </div>
      </div>
    </form>

    <template v-slot:footer>
      <div class="mr-4">
        <h2 v-translate>Pas de compte ?</h2>
      </div>
      <div>
        <router-link to="/register" class="create-account-link" v-translate>Créer un compte</router-link>
      </div>
    </template>
  </AuthForm>
</template>

<script>
import appUrl from 'lib/appUrl.js';
import { oauthBaseUrl, publicationAccessParameters } from 'config';
import AuthForm from './AuthForm.vue';
import ErrorMessages from './ErrorMessages.vue';
import { mapState } from 'vuex';
import toastr from 'mixins/toastrMixin.js';

export default {
  name: 'Login',
  components: { ErrorMessages, AuthForm },
  mixins: [toastr],
  computed: {
    ...mapState('auth', ['errors']),
    ...mapState('route', ['query']),
    isConfirmed() {
      return this.query.hasOwnProperty('confirmed');
    },
    privateMessage() {
      const { private_first_window_with_login_message: message } = publicationAccessParameters;
      return message && message[this.$language.current];
    },
    titles() {
      return {
        email: this.$gettext('Mail de connexion'),
        password: this.$gettext('Mot de passe'),
        submit: this.$gettext('Se connecter'),
      };
    },
  },
  methods: {
    async submit() {
      // TODO previous url handling
      await this.$store.dispatch('auth/login', this.credentials);
    },
  },
  mounted() {
    if (this.sessionExpired) {
      this.toastr('sessionExpired');
    }
    if (this.query.email) {
      this.credentials.email = this.query.email;
    }
  },
  data() {
    return {
      oauthBaseUrl,
      publicationAccessParameters,
      credentials: {
        email: '',
        password: '',
        remember_me: false,
      },
      forgotPasswordUrl: `${oauthBaseUrl}users/password/new?callback_url=${appUrl}`,
      sessionExpired: this.$route.query.session_expired,
    };
  },
};
</script>
